import type { FoodEntry, MealSlot } from "@shared/types";

export const SLOT_ORDER: MealSlot[] = ["breakfast", "lunch", "dinner", "snack"];

/** Bucket key for an entry. Legacy custom rows (plan_meal_slot = null) fall
 *  into "snack" as a pure display rule — no DB backfill. */
export function slotOf(e: FoodEntry): MealSlot {
  return e.plan_meal_slot ?? "snack";
}

export interface MealGroup {
  slot: MealSlot;
  items: FoodEntry[];
  subtotal: number;          // sum of item calories
}

/** Group the day's entries into the four meal buckets in SLOT_ORDER. Entries
 *  arrive ordered by eaten_at ASC from /api/today, so item order within a
 *  group is chronological for free. */
export function groupEntries(entries: FoodEntry[]): MealGroup[] {
  const buckets = new Map<MealSlot, FoodEntry[]>(SLOT_ORDER.map((s) => [s, []]));
  for (const e of entries) buckets.get(slotOf(e))!.push(e);
  return SLOT_ORDER.map((slot) => {
    const items = buckets.get(slot)!;
    return {
      slot,
      items,
      subtotal: items.reduce((s, e) => s + e.calories, 0),
    };
  });
}
